import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import * as Yup from "yup";
import React from "react";
import { SelectChangeEvent } from "@mui/material";
import MessageEnum, { getName } from "framework/src/Messages/MessageEnum";
import { configJSON } from "./CustomisableUserProfilesController";
import { getStorageData } from "framework/src/Utilities";
import moment from "moment";
// Customizable Area End
export interface Props {
  // Customizable Area Start
  open: boolean;
  onClose: () => void;
  onSave: (newEducations: any) => void;
  educationData: any | null;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  id: number;
  instituteName: string;
  qualification: string;
  instituteMonth: string;
  instituteYear: string;
  instituteEndMonth: string;
  instituteEndYear: string;
  ongoing: boolean;
  location: string;
  selectedStartYear: string[];
  selectedStartMonth: string[];
  selectedEndYear: string[];
  selectedEndMonth: string[];
  errors: {
    instituteName: string;
    qualification: string;
    instituteMonth: string;
    instituteYear: string;
    instituteEndMonth: string;
    instituteEndYear: string;
    location: string;
  };
  isLoading: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class EducationModalController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  userAddEducationApiCallId: string = "";
  editEducationApiCallId: string = "";
  // Customizable Area End
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.handleSaveData = this.handleSaveData.bind(this);
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      id: 0,
      instituteName: "",
      qualification: "",
      instituteMonth: "",
      instituteYear: "",
      instituteEndMonth: "",
      instituteEndYear: "",
      ongoing: false,
      location: "",
      selectedStartYear: [],
      selectedStartMonth: [],
      selectedEndYear: [],
      selectedEndMonth: [],
      errors: {
        instituteName: "",
        qualification: "",
        instituteMonth: "",
        instituteYear: "",
        instituteEndMonth: "",
        instituteEndYear: "",
        location: "",
      },
      isLoading: false,
      // Customizable Area End
    };
    // Customizable Area Start
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    if (this.props.educationData) {
      this.setState({
        id: this.props.educationData.id,
        instituteName: this.props.educationData.attributes?.institute_name,
        qualification: this.props.educationData.attributes?.qualification,
        instituteMonth: this.props.educationData.attributes?.start_date,
        instituteYear: this.props.educationData.attributes?.start_year,
        instituteEndMonth: this.props.educationData.attributes?.end_date,
        instituteEndYear: this.props.educationData.attributes?.end_year,
        ongoing: this.props.educationData.attributes?.is_ongoing,
        location: this.props.educationData.attributes?.location,
      });
    }
    // Customizable Area End
  }
  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      let responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (apiRequestCallId && responseJson) {
        if (apiRequestCallId === this.userAddEducationApiCallId) {
          this.props.onSave(responseJson.data);
          this.props.onClose();
        } else if (
          apiRequestCallId === this.editEducationApiCallId &&
          responseJson
        ) {
          this.props.onSave(responseJson.data);
          this.props.onClose?.();
        }
        this.setState({ isLoading: false });
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  validationSchema = Yup.object().shape({
    instituteName: Yup.string()
      .required("Institute Name is required")
      .max(250, "Institute name must be at most 250 characters!"),
    qualification: Yup.string()
      .trim()
      .required("Qualification is required")
      .max(250, "Qualification must be at most 250 characters!"),
    instituteMonth: Yup.string().required("Start month is required"),
    instituteYear: Yup.string().required("Start year is required"),
    instituteEndMonth: Yup.string()
      .nullable()
      .when("ongoing", {
        is: false,
        then: (schema: Yup.StringSchema) =>
          schema.required("Institute End month is required"),
        otherwise: (schema: Yup.StringSchema) => schema.notRequired(),
      }),
    instituteEndYear: Yup.string()
      .nullable()
      .when("ongoing", {
        is: false,
        then: Yup.string().required("Institute End year is required"),
        otherwise: Yup.string().notRequired(),
      })
      .test(
        "endDateCheck",
        "End date must be same or after start date and not in the future",
        function (instituteEndYear) {
          const { instituteYear, instituteMonth, instituteEndMonth, ongoing } =
            this.parent;

          if (ongoing) return true;
          if (
            !instituteYear ||
            !instituteMonth ||
            !instituteEndYear ||
            !instituteEndMonth
          ) {
            return true;
          }

          const startDate = moment(
            `${instituteYear}-${instituteMonth}-01`,
            "YYYY-MMMM-DD"
          );
          const endDate = moment(
            `${instituteEndYear}-${instituteEndMonth}-01`,
            "YYYY-MMMM-DD"
          );
          const today = moment().startOf("day");

          return (
            endDate.isSameOrAfter(startDate) && endDate.isSameOrBefore(today)
          );
        }
      ),
    location: Yup.string()
      .required("Location is required")
      .max(250, "Location must be at most 250 characters!"),
    ongoing: Yup.boolean(),
  });

  handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    this.setState(
      (prevState) => ({
        ongoing: isChecked,
        instituteEndMonth: isChecked ? "" : prevState.instituteEndMonth,
        instituteEndYear: isChecked ? "" : prevState.instituteEndYear,
        errors: {
          ...prevState.errors,
          ongoing: "",
          instituteEndMonth: "",
          instituteEndYear: "",
        },
      }),
      () => this.validateForm()
    );
  };

  handleLocationChange = (
    event: React.ChangeEvent<
      HTMLInputElement | { name?: string; value: unknown }
    >
  ) => {
    const { name, value } = event.target;
    const { errors } = this.state;
    if (this.state[name as keyof S] !== value) {
      this.setState(
        {
          [name as keyof S]: value,
          errors: { ...errors, [name as keyof S]: "" },
        } as Pick<S, keyof S>,
        () => {
          this.validateForm();
        }
      );
    }
  };

  validateForm = () => {
    const {
      instituteName,
      qualification,
      instituteMonth,
      instituteYear,
      instituteEndMonth,
      instituteEndYear,
      location,
      ongoing,
    } = this.state;
    return this.validationSchema
      .validate(
        {
          instituteName,
          qualification,
          instituteMonth,
          instituteYear,
          instituteEndMonth,
          instituteEndYear,
          location,
          ongoing,
        },
        { abortEarly: false }
      )
      .then(() => {
        this.setState({
          errors: {
            instituteName: "",
            qualification: "",
            instituteMonth: "",
            instituteYear: "",
            instituteEndMonth: "",
            instituteEndYear: "",
            location: "",
          },
        });
        return true;
      })
      .catch((err) => {
        const errors: any = {};
        err.inner.forEach((e: any) => {
          errors[e.path] = e.message;
        });
        this.setState({ errors });
        return false;
      });
  };

  isSaveDisabled = () => {
    const {
      instituteName,
      qualification,
      location,
      instituteMonth,
      instituteYear,
      instituteEndMonth,
      instituteEndYear,
      ongoing,
    } = this.state;
    const isFieldsFilled =
      instituteName &&
      qualification &&
      instituteMonth &&
      instituteYear &&
      location &&
      (ongoing || (instituteEndMonth && instituteEndYear));
    if (!isFieldsFilled) return true;
    if (!ongoing) {
      const startDate = new Date(`${instituteYear}-${instituteMonth}-01`);
      const endDate = new Date(`${instituteEndYear}-${instituteEndMonth}-01`);
      if (endDate <= startDate) return true;
    }
    return false;
  };

  handleSaveData = async () => {
    const isValid = await this.validateForm();
    if (isValid) {
      const { instituteEndMonth, instituteEndYear, ongoing, id } = this.state;
      const finalEndMonth = ongoing ? "" : instituteEndMonth;
      const finalEndYear = ongoing ? "" : instituteEndYear;
      const finalOngoing = ongoing || (!instituteEndMonth && !instituteEndYear);
      const newEducations = {
        id: this.state.id,
        instituteName: this.state.instituteName,
        qualification: this.state.qualification,
        instituteMonth: this.state.instituteMonth,
        instituteYear: this.state.instituteYear,
        instituteEndMonth: finalEndMonth,
        instituteEndYear: finalEndYear,
        ongoing: finalOngoing,
        location: this.state.location,
      };
      if (id) {
        await this.EditEducationDetails(id, newEducations);
      } else {
        await this.userEducationDetails(newEducations);
      }
    }
  };

  handleEndMonthChange = (event: SelectChangeEvent<string>) => {
    const { errors } = this.state;
    this.setState(
      {
        instituteEndMonth: event.target.value,
        ongoing: false,
        errors: { ...errors, instituteEndMonth: "", instituteEndYear: "" },
      },
      () => this.validateForm()
    );
  };

  handleEndYearChange = (event: SelectChangeEvent<string>) => {
    const { errors } = this.state;
    this.setState(
      {
        instituteEndYear: event.target.value,
        ongoing: false,
        errors: { ...errors, instituteEndYear: "" },
      },
      () => this.validateForm()
    );
  };

  handleInstituteMonthChange = (event: SelectChangeEvent<string>) => {
    const { errors } = this.state;
    this.setState(
      {
        instituteMonth: event.target.value,
        errors: { ...errors, instituteMonth: "" },
      },
      () => this.validateForm()
    );
  };

  handleInstituteYearChange = (event: SelectChangeEvent<string>) => {
    const { errors } = this.state;
    this.setState(
      {
        instituteYear: event.target.value,
        errors: { ...errors, instituteYear: "" },
      },
      () => this.validateForm()
    );
  };

  handleQualificationChange = (event: { target: { value: any } }) => {
    const { errors } = this.state;
    this.setState({
      qualification: event.target.value,
      errors: { ...errors, qualification: "" },
    });
  };

  CustomCheckedIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="6" fill="#652784" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.0611 5.42238C15.5183 5.73229 15.6376 6.35411 15.3277 6.81124L10.2432 14.3112C10.0771 14.5562 9.8111 14.715 9.51671 14.745C9.22232 14.7749 8.92977 14.673 8.71777 14.4665L4.80234 10.6536C4.40667 10.2683 4.39827 9.6352 4.78358 9.23953C5.16888 8.84386 5.80199 8.83546 6.19766 9.22077L9.25771 12.2007L13.6723 5.68895C13.9822 5.23182 14.604 5.11247 15.0611 5.42238Z"
        fill="white"
      />
    </svg>
  );

  CustomUncheckedIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#94A3B8" />
    </svg>
  );

  buildEducationFormData(newEducations: any, includeId = false) {
    const formData = new FormData();
    if (includeId && newEducations.id) {
      formData.append("id", String(newEducations.id));
    }
    formData.append("institute_name", newEducations.instituteName);
    formData.append("qualification", newEducations.qualification);
    formData.append("start_date", newEducations.instituteMonth);
    formData.append("start_year", String(newEducations.instituteYear));
    formData.append("end_date", newEducations.instituteEndMonth);
    formData.append("end_year", String(newEducations.instituteEndYear));
    formData.append("location", newEducations.location);
    formData.append("is_ongoing", String(newEducations.ongoing));
    return formData;
  }

  userEducationDetails = async (newEducations: any) => {
    this.setState({ isLoading: true });
    const token = await getStorageData(configJSON.TOKEN);
    const formData = this.buildEducationFormData(newEducations, true);
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.userAddEducationApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.addEducationAndTraining
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({ token })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  EditEducationDetails = async (id: number, newEducations: any) => {
    this.setState({ isLoading: true });
    const token = await getStorageData(configJSON.TOKEN);
    const formData = this.buildEducationFormData(newEducations);
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.editEducationApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.addEducationAndTraining}/${id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({ token })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPatchMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // Customizable Area End
}
